<button
  type="button"
  class="language-trigger"
  aria-label="Switch language"
  (click)="toggleLanguage()"
>
  <sham-i-language-square class="size-4!" />
</button>
